import { createJSONStorage, StateStorage } from "zustand/middleware";

const storageAdapter: StateStorage = {
  getItem: (name) => {
    return localStorage.getItem(name) || sessionStorage.getItem(name);
  },
  setItem: (name, value) => {
    if (localStorage.getItem("rememberMe") === "true") {
      localStorage.setItem(name, value);
    } else {
      sessionStorage.setItem(name, value);
    }
  },
  removeItem: (name) => {
    localStorage.removeItem(name);
    sessionStorage.removeItem(name);
  },
};

export const customStorage = createJSONStorage(() => storageAdapter);
